import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import MediaKit from "./pages/MediaKit";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/media-kit" element={<MediaKit />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0B1C33",
            color: "#F9F7F2",
            border: "1px solid #C45F45",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
            fontSize: "15px",
          },
        }}
      />
    </div>
  );
}

export default App;
